import { rotationAnimationName } from '~/actions/extraHTML/wheelOfFortune/const';

export const rotationCss = () => `
@keyframes ${rotationAnimationName} {
  0% {
    transform: rotate(var(--min-rotate-value));
    animation-timing-function: ease-in-out;
  }

  40% {
    animation-timing-function: ease-out;
  }

  100% {
    transform: rotate(var(--max-rotate-value));
    animation-timing-function: ease-out;
  }
}
`;
